
import React from 'react'
import Header from '../components/header/Header'

import Footer from '../components/footer/Footer'
import Blogpost from '../components/blogpost/Blogpost'

const Blogs = () => {
  return (
    <>
    <Header/>
    <Blogpost/>
    <Footer/>
    </>
  )
}

export default Blogs